import React from "react";
import { useHistory } from "react-router";

import Styles from "./Navbar.module.css";
import ActionButton from "./ActionButton.js";

function Navbar(props) {
  var history = useHistory();
  return (
    <nav>
      <h1
        onClick={() => {
          history.push("/");
        }}
        className={Styles.logo}
      >
        Mata
      </h1>

      <div className={Styles.divider}></div>
      <ActionButton
        label={props.actionButtonText || "Contact Me"}
        icon={props.actionButtonIcon || "forward"}
        iconStyles={{ marginLeft: "auto", marginRight:"10px" }}
        onClick={() => {
          history.push(props.actionButtonRoute || "/contact-me");
        }}
      />
    </nav>
  );
}

export default Navbar;
